module.exports = __webpack_public_path__ + "static/media/card-blog6.7e4fdf9a.jpg";